import script from "./InspectorEnvironment.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectorEnvironment.vue?vue&type=script&setup=true&lang=js"

import "./InspectorEnvironment.vue?vue&type=style&index=0&id=42763c3c&lang=scss&scoped=true"
import "./InspectorEnvironment.vue?vue&type=style&index=1&id=42763c3c&lang=css"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/online-3d-editor-laozicloud3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42763c3c"]])

export default __exports__